<template>
    <div class="box is-condensed mb-5">
        <p class="mb-2 has-text-weight-bold">{{ translate("common.options") }}:</p>
        <div class="field mb-3">
            <div v-if="optionsLoading" class="is-flex is-align-items-center">
                <InlineSpinner />
            </div>
            <Checkbox2 v-else v-model="useBirthDateForCategoryMatching">
                {{ translate("event_setting.useBirthDateForCategoryMatching") }}
            </Checkbox2>
        </div>
        <LoadingButton :disabled="optionsLoading" :is-loading="savingOptionsInProgress" class="button is-small" @click="saveOptions">
            {{ translate("page.registration_stage.save_options") }}
        </LoadingButton>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from "vue";
    import { translate } from "../Common/translations";
    import { handleError } from "../Common/errorHandler";
    import { successToast } from "../Common/toasts";
    import Checkbox2 from "../Common/Checkbox2.vue";
    import InlineSpinner from "../Common/InlineSpinner.vue";
    import LoadingButton from "../Common/LoadingButton.vue";
    import categoriesApi from "../Api/Categories/categories";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";

    const store = useCategoriesManagerStore();

    const useBirthDateForCategoryMatching = ref(false);
    const optionsLoading = ref(true);
    const savingOptionsInProgress = ref(false);

    onMounted(() => {
        categoriesApi
            .getCategoriesOptions(store.eventId)
            .then(options => {
                useBirthDateForCategoryMatching.value = options.useBirthDateForCategoryMatching;
            })
            .catch(handleError)
            .finally(() => {
                optionsLoading.value = false;
            });
    });

    function saveOptions() {
        savingOptionsInProgress.value = true;
        categoriesApi
            .saveCategoriesOptions(store.eventId, {
                useBirthDateForCategoryMatching: useBirthDateForCategoryMatching.value,
            })
            .then(() => {
                successToast(translate("common.changes_have_been_saved"));
            })
            .catch(handleError)
            .finally(() => {
                savingOptionsInProgress.value = false;
            });
    }
</script>
